export default "__VITE_ASSET__CoXIWVff__"